import { useMemo } from "react";

import type { ScopeKey } from "@/lib/api/queryKeys";
import { useContextStore } from "@/store/contextStore";

/**
 * The scope the API client will send, as a query-key part.
 *
 * Read from the same store the request interceptor reads (`lib/api/client.ts`),
 * so the key changes exactly when the `X-Context-*` headers do. A query whose
 * answer depends on those headers must put this in its key: the request's own
 * params cannot show the scope, and without it the cache hands one
 * organisation's answer to another after a scope switch.
 */
export function useScopeKey(): ScopeKey {
  const scope = useContextStore((s) => s.scope);
  const distributor = useContextStore((s) => s.distributorId);
  const msp = useContextStore((s) => s.mspId);
  const company = useContextStore((s) => s.companyId);
  return useMemo(
    () => ({ scope, distributor, msp, company }),
    [scope, distributor, msp, company],
  );
}
